<template>
	<div class="mt-8 flex-1 h-0 overflow-y-auto text-xl md:text-base">
		<nav class="px-4 space-y-2 md:space-y-1">
			<page-link
				v-for="item in items"
				:key="item.label"
				:href="item.href"
				:acl="item.acl_soft"
				:class="[
					'relative group flex items-center px-3 py-2 text-white font-medium rounded-2xl cursor-pointer',
					isActive(item)
						? 'md:bg-green bg-green-600'
						: 'hover:bg-green-600 md:hover:bg-gray-100 md:text-gray-700 md:hover:text-gray-900',
				]"
			>
				<ui-icon
					:class="[
						'mr-4 md:mr-3 flex-shrink-0 h-7 w-7 md:h-5 md:w-5 text-white',
						isActive(item) ? '' : 'md:text-gray-600',
					]"
					:name="item.icon"
					stroke-width="2"
				/>
				{{ __(item.label) }}
				<!-- absolute top-0 right-0 translate-x-1/4 -translate-y-1/2 -->
				<span
					class="ml-3 inline-flex shadow-md md:shadow-none items-center justify-center px-3 py-2 md:px-2 md:py-1 text-base md:text-xs font-bold leading-none text-white transform bg-orange rounded-full"
					v-if="item.count"
					>{{ item.count }}</span
				>
			</page-link>
		</nav>
	</div>
</template>

<script>
export default {
	data() {
		let acl = this.$inertia.page.props.acl;
		return {
			acl: acl,
		};
	},
	methods: {
		isActive(item) {
			let url = this.$inertia.page.url;
			return url.match(item.activeIf || item.href) !== null;
		},
	},
	computed: {
		notifications() {
			let that = this;
			return this.$inertia.page.props.unreadMessages.map(function (m) {
				return {
					from: m.counterpart.company_name,
					text:
						m.type == "BID" ? __("You have received a new offer!") : m.message,
					link: that.$route("threads", { active_id: m.thread_id }),
				};
			});
		},
		unreadCount() {
			return this.notifications.length;
		},
		items() {
			return [
				{
					label: "Start",
					icon: "barn",
					href: "/start",
				},
				{
					label: "Price Ticker",
					icon: "fa-euro-sign",
					href: "/price_indications",
					acl: "can_priceindications",
				},
				{
					label: "My Lots",
					icon: "fa-wheat",
					href: "/offers",
					acl: "can_trade",
				},
				{
					label: "My Negotiations",
					icon: "fa-messages",
					href: "/threads",
					acl: "can_trade",
					count: this.unreadCount,
				},
				{
					label: "My Contracts",
					icon: "fa-handshake",
					href: "/my_contracts",
					acl: "can_dashboard",
				},
				{
					label: "Search",
					icon: "fa-magnifying-glass",
					href: "/search",
				},
				{
					label: "Paper Market",
					icon: "fa-file-certificate",
					href: "/paper",
					acl: "can_paper",
				},
				{
					label: "Market News",
					icon: "fa-chart-line-up",
					href: "/content/compass",
					acl: "has_complete_profile",
				},
				{
					label: "Auction",
					icon: "hammer",
					href: "/auction",
					acl: "can_auction",
				},
				{
					label: "Admin",
					icon: "sliders",
					href: "/admin",
					acl: "admin",
				},
			].filter((item) => item.acl == null || this.acl[item.acl] == true);
		},
	},
};
</script>
